<template>
	<div :class="`menu_sec ${isAddBackgroudToNav && 'nav-background'}`">
		<div class="desktop_menu">
			<div class="container">
				<div class="row">
					<div class="col-sm-9 col-xxl-9 col-xl-8 col-lg-8 col-md-8">
						<nav :class="`navbar navbar-expand-lg navbar-light`">
							<div class="container-fluid ps-0">
								<a class="navbar-brand" href="/"
									><img style="width: 200px" :src="img.image1" alt="Logo"
								/></a>

								<button
									class="navbar-toggler"
									type="button"
									data-bs-toggle="collapse"
									data-bs-target="#navbarNav"
									aria-controls="navbarNav"
									aria-expanded="false"
									:aria-label="
										$t(
											'new_ui.components.header_component.accessibility.toggle_navigation',
										)
									"
								>
									<span class="navbar-toggler-icon"></span>
								</button>
								<div class="collapse navbar-collapse" id="navbarNav">
									<ul class="navbar-nav justify-content-end w-100">
										<li class="nav-item dropdown">
											<a
												class="nav-link dropdown-toggle active"
												href="#"
												id="navbarDropdown"
												role="button"
												data-bs-toggle="dropdown"
												aria-expanded="false"
											>
												{{
													$t(
														'new_ui.components.header_component.navigation.individual.label',
													)
												}}
												<i class="fas fa-chevron-down ms-1"></i>
											</a>
											<ul
												class="dropdown-menu"
												aria-labelledby="navbarDropdown"
											>
												<li>
													<a
														class="dropdown-item"
														href="javascript:void(0)"
														v-on:click="
															$router.push({
																path: '/personal/how/online_shopping',
															})
														"
														>{{
															$t(
																'new_ui.components.header_component.navigation.individual.menu_items.online_shopping',
															)
														}}</a
													>
												</li>
												<li>
													<a
														class="dropdown-item"
														href="javascript:void(0)"
														v-on:click="
															$router.push({
																path: '/personal/how/offline_kiosk',
															})
														"
														>{{
															$t(
																'new_ui.components.header_component.navigation.individual.menu_items.offline_kiosk',
															)
														}}</a
													>
												</li>
												<li>
													<a
														class="dropdown-item"
														href="javascript:void(0)"
														v-on:click="
															$router.push({
																path: '/personal/how/qr',
															})
														"
														>{{
															$t(
																'new_ui.components.header_component.navigation.individual.menu_items.pay_with_qr',
															)
														}}</a
													>
												</li>
												<li>
													<a
														class="dropdown-item"
														href="javascript:void(0)"
														v-on:click="
															$router.push({
																path: '/personal/how/trade_and_cashback',
															})
														"
														>{{
															$t(
																'new_ui.components.header_component.navigation.individual.menu_items.transaction_cashback',
															)
														}}</a
													>
												</li>
												<li>
													<a
														class="dropdown-item"
														href="javascript:void(0)"
														v-on:click="
															$router.push({
																path: '/personal/request/send',
															})
														"
														>{{
															$t(
																'new_ui.components.header_component.navigation.individual.menu_items.send_asset',
															)
														}}</a
													>
												</li>
												<li>
													<a
														class="dropdown-item"
														href="javascript:void(0)"
														v-on:click="
															$router.push({
																path: '/personal/request/receive',
															})
														"
														>{{
															$t(
																'new_ui.components.header_component.navigation.individual.menu_items.asset_request',
															)
														}}</a
													>
												</li>
												<li>
													<a
														class="dropdown-item"
														href="javascript:void(0)"
														v-on:click="
															$router.push({
																path: '/personal/request/deposit',
															})
														"
														>{{
															$t(
																'new_ui.components.header_component.navigation.individual.menu_items.get_deposit',
															)
														}}</a
													>
												</li>
												<li>
													<a
														class="dropdown-item"
														href="javascript:void(0)"
														v-on:click="
															$router.push({
																path: '/personal/request/commission',
															})
														"
														>{{
															$t(
																'new_ui.components.header_component.navigation.individual.menu_items.fee',
															)
														}}</a
													>
												</li>
												<li>
													<a
														class="dropdown-item"
														href="javascript:void(0)"
														v-on:click="
															$router.push({
																path: '/personal/asset/wallet',
															})
														"
														>{{
															$t(
																'new_ui.components.header_component.navigation.individual.menu_items.wallet',
															)
														}}</a
													>
												</li>
												<li>
													<a
														class="dropdown-item"
														href="javascript:void(0)"
														v-on:click="
															$router.push({
																path: '/personal/asset/account',
															})
														"
														>{{
															$t(
																'new_ui.components.header_component.navigation.individual.menu_items.account',
															)
														}}</a
													>
												</li>
												<li>
													<a
														class="dropdown-item"
														href="javascript:void(0)"
														v-on:click="
															$router.push({
																path: '/personal/asset/sale',
															})
														"
														>{{
															$t(
																'new_ui.components.header_component.navigation.individual.menu_items.sell',
															)
														}}</a
													>
												</li>
												<li>
													<a
														class="dropdown-item"
														href="javascript:void(0)"
														v-on:click="
															$router.push({
																path: '/personal/asset/exchange',
															})
														"
														>{{
															$t(
																'new_ui.components.header_component.navigation.individual.menu_items.exchanging_currency',
															)
														}}</a
													>
												</li>
											</ul>
										</li>
										<li class="nav-item dropdown">
											<a
												class="nav-link dropdown-toggle"
												href="#"
												id="navbarDropdown"
												role="button"
												data-bs-toggle="dropdown"
												aria-expanded="false"
											>
												{{
													$t(
														'new_ui.components.header_component.navigation.business.label',
													)
												}}
												<i class="fas fa-chevron-down ms-1"></i>
											</a>
											<ul
												class="dropdown-menu"
												aria-labelledby="navbarDropdown"
											>
												<li>
													<a
														class="dropdown-item"
														href="javascript:void(0)"
														v-on:click="
															$router.push({
																path: '/business/how/start',
															})
														"
														>{{
															$t(
																'new_ui.components.header_component.navigation.business.menu_items.getting_Started',
															)
														}}</a
													>
												</li>
												<li>
													<a
														class="dropdown-item"
														href="javascript:void(0)"
														v-on:click="
															$router.push({
																path: '/business/how/receive',
															})
														"
														>{{
															$t(
																'new_ui.components.header_component.navigation.business.menu_items.accepting_payment',
															)
														}}</a
													>
												</li>
												<li>
													<a
														class="dropdown-item"
														href="javascript:void(0)"
														v-on:click="
															$router.push({
																path: '/business/how/pay',
															})
														"
														>{{
															$t(
																'new_ui.components.header_component.navigation.business.menu_items.make_a_payment',
															)
														}}</a
													>
												</li>
												<li>
													<a
														class="dropdown-item"
														href="javascript:void(0)"
														v-on:click="
															$router.push({
																path: '/business/how/risk',
															})
														"
														>{{
															$t(
																'new_ui.components.header_component.navigation.business.menu_items.risk_management',
															)
														}}</a
													>
												</li>
												<li>
													<a
														class="dropdown-item"
														href="javascript:void(0)"
														v-on:click="
															$router.push({
																path: '/business/operation/corps',
															})
														"
														>{{
															$t(
																'new_ui.components.header_component.navigation.business.menu_items.about_company',
															)
														}}</a
													>
												</li>
												<li>
													<a
														class="dropdown-item"
														href="javascript:void(0)"
														v-on:click="
															$router.push({
																path: '/business/operation/platform',
															})
														"
														>{{
															$t(
																'new_ui.components.header_component.navigation.business.menu_items.platforms_features',
															)
														}}</a
													>
												</li>
												<li>
													<a
														class="dropdown-item"
														href="javascript:void(0)"
														v-on:click="
															$router.push({
																path: '/business/operation/pay',
															})
														"
														>{{
															$t(
																'new_ui.components.header_component.navigation.business.menu_items.payment_method',
															)
														}}</a
													>
												</li>
												<li>
													<a
														class="dropdown-item"
														href="javascript:void(0)"
														v-on:click="
															$router.push({
																path: '/business/operation/global',
															})
														"
														>{{
															$t(
																'new_ui.components.header_component.navigation.business.menu_items.global_payment',
															)
														}}</a
													>
												</li>
												<li>
													<a
														class="dropdown-item"
														href="javascript:void(0)"
														v-on:click="
															$router.push({
																path: '/business/pay',
															})
														"
														>{{
															$t(
																'new_ui.components.header_component.navigation.business.menu_items.processing',
															)
														}}</a
													>
												</li>
											</ul>
										</li>

										<li>
											<a
												class="dropdown-item"
												href="javascript:void(0)"
												v-on:click="
													$router.push({
														path: '/development/main',
													})
												"
												>{{
													$t(
														'new_ui.components.header_component.navigation.development.label',
													)
												}}</a
											>
										</li>

										<li class="nav-item">
											<a
												class="nav-link"
												:href="$router.resolve({ name: 'user-inquiry' }).href"
												>{{
													$t(
														'new_ui.components.header_component.navigation.customer_service.label',
													)
												}}</a
											>
										</li>
									</ul>
								</div>
							</div>
						</nav>
					</div>
					<div class="col-sm-3 col-xxl-3 col-xl-4 col-lg-4 col-md-4">
						<div
							class="head_btn_sec d-flex justify-content-end align-items-center"
						>
							<div class="language_sec">
								<div class="language-selector">
									<img
										:src="img.image2"
										:alt="
											$t(
												'new_ui.components.header_component.accessibility.language_selector.alt',
											)
										"
									/>
									<div class="dropdown">
										<div
											v-for="item in locales"
											:key="item.code"
											@click="s_locale_code = item.code"
											:class="{ active: s_locale_code === item.code }"
										>
											{{ item.name }}
										</div>
									</div>
								</div>
							</div>
							<a :href="$router.resolve({ name: 'auth-login' }).href">{{
								$t('new_ui.components.header_component.auth.login')
							}}</a>
							<a
								:href="$router.resolve({ name: 'auth-register' }).href"
								class="back_on"
								>{{ $t('new_ui.components.header_component.auth.signup') }}</a
							>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="mobile_menu">
			<div class="hamburger-menu">
				<div class="container">
					<div class="row">
						<div class="col-md-3 col-sm-3 col-4">
							<div class="logo">
								<a class="" href="/"
									><img
										:src="img.image1"
										:alt="
											$t(
												'new_ui.components.header_component.accessibility.logo_alt',
											)
										"
								/></a>
							</div>
						</div>
						<div class="col-md-9 col-sm-9 col-8">
							<div class="language_sec">
								<div class="language-selector">
									<img
										:src="img.image4"
										:alt="
											$t(
												'new_ui.components.header_component.accessibility.language_selector.alt',
											)
										"
									/>
									<div class="dropdown">
										<div
											v-for="item in locales"
											:key="item.code"
											@click="s_locale_code = item.code"
											:class="{ active: s_locale_code === item.code }"
										>
											{{ item.name }}
										</div>
									</div>
								</div>
							</div>
							<div
								@click="changeMobileNavOpen"
								:class="`menu-tigger ${isMobileNavOpen && 'button-tigger'}`"
							>
								<span></span>
								<span></span>
								<span></span>
							</div>
							<nav :class="`${isMobileNavOpen && 'res-menu'}`">
								<ul>
									<li
										class="has-submenu"
										@click="toggleIndividualSubmenu"
										:class="{ open: isIndividualOpen }"
									>
										<a
											class="nav-link dropdown-toggle active"
											href="#"
											id="navbarDropdown"
											role="button"
											data-bs-toggle="dropdown"
											aria-expanded="false"
										>
											{{
												$t(
													'new_ui.components.header_component.navigation.individual.label',
												)
											}}
											<i
												class="fa fa-chevron-down caret"
												:class="{ rotated: isIndividualOpen }"
											></i>
										</a>
										<ul class="submenu">
											<li>
												<a
													class="dropdown-item"
													href="javascript:void(0)"
													v-on:click="
														$router.push({
															path: '/personal/how/online_shopping',
														})
													"
													>{{
														$t(
															'new_ui.components.header_component.navigation.individual.menu_items.online_shopping',
														)
													}}</a
												>
											</li>
											<li>
												<a
													class="dropdown-item"
													href="javascript:void(0)"
													v-on:click="
														$router.push({
															path: '/personal/how/offline_kiosk',
														})
													"
													>{{
														$t(
															'new_ui.components.header_component.navigation.individual.menu_items.offline_kiosk',
														)
													}}</a
												>
											</li>
											<li>
												<a
													class="dropdown-item"
													href="javascript:void(0)"
													v-on:click="
														$router.push({
															path: '/personal/how/qr',
														})
													"
													>{{
														$t(
															'new_ui.components.header_component.navigation.individual.menu_items.pay_with_qr',
														)
													}}</a
												>
											</li>
											<li>
												<a
													class="dropdown-item"
													href="javascript:void(0)"
													v-on:click="
														$router.push({
															path: '/personal/how/trade_and_cashback',
														})
													"
													>{{
														$t(
															'new_ui.components.header_component.navigation.individual.menu_items.transaction_cashback',
														)
													}}</a
												>
											</li>
											<li>
												<a
													class="dropdown-item"
													href="javascript:void(0)"
													v-on:click="
														$router.push({
															path: '/personal/request/send',
														})
													"
													>{{
														$t(
															'new_ui.components.header_component.navigation.individual.menu_items.send_asset',
														)
													}}</a
												>
											</li>
											<li>
												<a
													class="dropdown-item"
													href="javascript:void(0)"
													v-on:click="
														$router.push({
															path: '/personal/request/receive',
														})
													"
													>{{
														$t(
															'new_ui.components.header_component.navigation.individual.menu_items.asset_request',
														)
													}}</a
												>
											</li>
											<li>
												<a
													class="dropdown-item"
													href="javascript:void(0)"
													v-on:click="
														$router.push({
															path: '/personal/request/deposit',
														})
													"
													>{{
														$t(
															'new_ui.components.header_component.navigation.individual.menu_items.get_deposit',
														)
													}}</a
												>
											</li>
											<li>
												<a
													class="dropdown-item"
													href="javascript:void(0)"
													v-on:click="
														$router.push({
															path: '/personal/request/commission',
														})
													"
													>{{
														$t(
															'new_ui.components.header_component.navigation.individual.menu_items.fee',
														)
													}}</a
												>
											</li>
											<li>
												<a
													class="dropdown-item"
													href="javascript:void(0)"
													v-on:click="
														$router.push({
															path: '/personal/asset/wallet',
														})
													"
													>{{
														$t(
															'new_ui.components.header_component.navigation.individual.menu_items.wallet',
														)
													}}</a
												>
											</li>
											<li>
												<a
													class="dropdown-item"
													href="javascript:void(0)"
													v-on:click="
														$router.push({
															path: '/personal/asset/account',
														})
													"
													>{{
														$t(
															'new_ui.components.header_component.navigation.individual.menu_items.account',
														)
													}}</a
												>
											</li>
											<li>
												<a
													class="dropdown-item"
													href="javascript:void(0)"
													v-on:click="
														$router.push({
															path: '/personal/asset/sale',
														})
													"
													>{{
														$t(
															'new_ui.components.header_component.navigation.individual.menu_items.sell',
														)
													}}</a
												>
											</li>
											<li>
												<a
													class="dropdown-item"
													href="javascript:void(0)"
													v-on:click="
														$router.push({
															path: '/personal/asset/exchange',
														})
													"
													>{{
														$t(
															'new_ui.components.header_component.navigation.individual.menu_items.exchanging_currency',
														)
													}}</a
												>
											</li>
										</ul>
									</li>
									<li
										class="has-submenu"
										@click="toggleBusinessSubmenu"
										:class="{ open: isBusinessOpen }"
									>
										<a href="#"
											>{{
												$t(
													'new_ui.components.header_component.navigation.business.label',
												)
											}}
											<i
												class="fa fa-chevron-down caret"
												:class="{ rotated: isBusinessOpen }"
											></i
										></a>
										<!-- Added missing business submenu -->
										<ul class="submenu">
											<li>
												<a
													class="dropdown-item"
													href="javascript:void(0)"
													v-on:click="
														$router.push({
															path: '/business/how/start',
														})
													"
													>{{
														$t(
															'new_ui.components.header_component.navigation.business.menu_items.getting_Started',
														)
													}}</a
												>
											</li>
											<li>
												<a
													class="dropdown-item"
													href="javascript:void(0)"
													v-on:click="
														$router.push({
															path: '/business/how/receive',
														})
													"
													>{{
														$t(
															'new_ui.components.header_component.navigation.business.menu_items.accepting_payment',
														)
													}}</a
												>
											</li>
											<li>
												<a
													class="dropdown-item"
													href="javascript:void(0)"
													v-on:click="
														$router.push({
															path: '/business/how/pay',
														})
													"
													>{{
														$t(
															'new_ui.components.header_component.navigation.business.menu_items.make_a_payment',
														)
													}}</a
												>
											</li>
											<li>
												<a
													class="dropdown-item"
													href="javascript:void(0)"
													v-on:click="
														$router.push({
															path: '/business/how/risk',
														})
													"
													>{{
														$t(
															'new_ui.components.header_component.navigation.business.menu_items.risk_management',
														)
													}}</a
												>
											</li>
											<li>
												<a
													class="dropdown-item"
													href="javascript:void(0)"
													v-on:click="
														$router.push({
															path: '/business/how/risk',
														})
													"
													>{{
														$t(
															'new_ui.components.header_component.navigation.business.menu_items.risk_management',
														)
													}}</a
												>
											</li>
											<li>
												<a
													class="dropdown-item"
													href="javascript:void(0)"
													v-on:click="
														$router.push({
															path: '/business/operation/corps',
														})
													"
													>{{
														$t(
															'new_ui.components.header_component.navigation.business.menu_items.about_company',
														)
													}}</a
												>
											</li>
											<li>
												<a
													class="dropdown-item"
													href="javascript:void(0)"
													v-on:click="
														$router.push({
															path: '/business/operation/platform',
														})
													"
													>{{
														$t(
															'new_ui.components.header_component.navigation.business.menu_items.platforms_features',
														)
													}}</a
												>
											</li>
											<li>
												<a
													class="dropdown-item"
													href="javascript:void(0)"
													v-on:click="
														$router.push({
															path: '/business/operation/pay',
														})
													"
													>{{
														$t(
															'new_ui.components.header_component.navigation.business.menu_items.payment_method',
														)
													}}</a
												>
											</li>
											<li>
												<a
													class="dropdown-item"
													href="javascript:void(0)"
													v-on:click="
														$router.push({
															path: '/business/operation/global',
														})
													"
													>{{
														$t(
															'new_ui.components.header_component.navigation.business.menu_items.global_payment',
														)
													}}</a
												>
											</li>
											<li>
												<a
													class="dropdown-item"
													href="javascript:void(0)"
													v-on:click="
														$router.push({
															path: '/business/pay',
														})
													"
													>{{
														$t(
															'new_ui.components.header_component.navigation.business.menu_items.processing',
														)
													}}</a
												>
											</li>
										</ul>
									</li>
									<li>
										<a
											class="dropdown-item"
											href="javascript:void(0)"
											v-on:click="
												$router.push({
													path: '/development/main',
												})
											"
											>{{
												$t(
													'new_ui.components.header_component.navigation.development.label',
												)
											}}</a
										>
									</li>

									<li class="nav-item">
										<a
											class="nav-link"
											:href="$router.resolve({ name: 'user-inquiry' }).href"
											>{{
												$t(
													'new_ui.components.header_component.navigation.customer_service.label',
												)
											}}</a
										>
									</li>
								</ul>
								<div class="head_btn_sec">
									<a
										:href="$router.resolve({ name: 'auth-login' }).href"
										class="login"
										>{{
											$t('new_ui.components.header_component.auth.login')
										}}</a
									>
									<a
										:href="$router.resolve({ name: 'auth-register' }).href"
										class="back_on signup"
										>{{
											$t('new_ui.components.header_component.auth.signup')
										}}</a
									>
								</div>
							</nav>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex';
import img from '@/assets/images/sub/main_logo.png';
import lang from '@/assets/images/sub/Language.png';
import moblang from '@/assets/images/sub/mob_lang.png';
import colormoblang from '@/assets/images/sub/colormob_lang.png';
export default {
	data: () => {
		return {
			img: {
				image1: img,
				image2: lang,
				image3: moblang,
				image4: colormoblang,
			},
			isMobileNavOpen: false,
			isBusinessOpen: false,
			isIndividualOpen: false,
			isAddBackgroudToNav: false,
		};
	},
	mounted() {
		window.addEventListener('scroll', this.handleScroll);
	},
	beforeUnmount() {
		window.removeEventListener('scroll', this.handleScroll);
	},
	methods: {
		changeMobileNavOpen() {
			this.isMobileNavOpen = !this.isMobileNavOpen;
		},

		toggleBusinessSubmenu() {
			this.isBusinessOpen = !this.isBusinessOpen;
		},
		toggleIndividualSubmenu() {
			this.isIndividualOpen = !this.isIndividualOpen;
		},
		handleScroll() {
			if (window.scrollY > 120) {
				this.isAddBackgroudToNav = true;
			} else {
				this.isAddBackgroudToNav = false;
			}
		},
	},
	computed: {
		// language
		...mapState('common', ['locales']),
		s_locale_code: {
			get() {
				return this.$store.state.common.locale;
			},
			set(value) {
				this.$store.dispatch('common/setLocale', value);
			},
		},
		getCurrentLanguage() {
			const currentLocale = this.locales.find(
				locale => locale.code === this.s_locale_code,
			);
			return currentLocale ? currentLocale.name : 'English';
		},
	},
};
</script>

<style scoped>
.language-selector {
	position: relative;
	cursor: pointer;
}

.language-selector .dropdown {
	position: absolute;
	top: 100%;
	right: 0;
	background: white;
	border-radius: 8px;
	box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
	display: none;
	min-width: 120px;
	z-index: 1000;
}

.language-selector:hover .dropdown {
	display: block;
}

.language-selector .dropdown div {
	padding: 8px 16px;
	cursor: pointer;
	transition: background-color 0.2s;
}

.language-selector .dropdown div:hover {
	background-color: #d4b360;
}

.language-selector .dropdown div.active {
	background-color: #b9994b;
	font-weight: 500;
	color: #fff;
	border-radius: 8px;
}

.language-selector img {
	margin-right: 8px;
	vertical-align: middle;
}
</style>
